import { Typography } from "@mui/material";
export function getLayoutHead(v) {
  return (
    <Typography
      variant="h3"
      fontFamily="Lato-Regular"
      sx={{
        pb: 3,
        color: (theme) => theme.palette.grey[500],
        "& span": {
          color: "primary.main",
        },
      }}
    >
      {v}
    </Typography>
  );
}
